import * as DashboardApi from 'api/dashboard';
import * as ProgramApi from 'api/program';
import { DATA_BAG } from 'defs/offlineAvailability';
import Sequences from 'defs/sequences';
import EventWrapper from 'models/global/EventWrapper';
import { call, fork, put, select } from 'redux-saga/effects';
import * as profileSagas from 'sagas/profile';
import * as programOverviewSagas from 'sagas/programOverview';
import { actionCreators as connectionAC, getIsOnline } from 'store/connection';
import { actionCreators } from 'store/dashboard';
import { MEASUREMENT_DIAGRAM_TYPE } from 'store/dashboard/dashboard';
import { actionCreators as eventsAC } from 'store/events';
import { getIsMigrosAuthenticated } from 'store/login';
import { actionCreators as offlineAvailabilityAC } from 'store/offlineAvailability';
import { getIsPreviewUser } from 'store/profile';
import { actionCreators as sequenceAC } from 'store/sequences';
import { Generator as ReduxGenerator } from 'types/Redux';

export function* loadDashboard(action: any) {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkFetchRequestError());
	}

	action = action || {
		preventUpdateLoadingState: false,
	};

	const preventUpdateLoadingState: boolean =
		typeof action.preventUpdateLoadingState === 'boolean' ? action.preventUpdateLoadingState : false;

	const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);

	if (!isMigrosAuthenticated) {
		return void 0;
	}

	if (!preventUpdateLoadingState) {
		yield put(actionCreators.doDashboardLoading(true));
	}
	try {
		const dashboard = yield call(DashboardApi.fetchDashboard);

		if (dashboard.programExternalId) {
			const isPreviewUser = yield select(getIsPreviewUser);
			const program = yield call(ProgramApi.fetchProgramPreview, dashboard.programExternalId, isPreviewUser);

			yield put(actionCreators.doReceivedProgram(program));
		}

		if (!preventUpdateLoadingState) {
			yield put(actionCreators.doDashboardLoading(false));
		}

		yield put(offlineAvailabilityAC.doRegisterDataBag(DATA_BAG.DASHBOARD));
		yield put(actionCreators.doReceivedOverview(dashboard));
		// tslint:disable-next-line: no-empty
	} catch (e) {}
}

export function* loadDashboardMeasurement(): ReduxGenerator {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return;
	}

	const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);
	if (!isMigrosAuthenticated) {
		return void 0;
	}

	try {
		const profileMeasurement = yield call(DashboardApi.fetchDashboardMeasurement);
		yield put(actionCreators.doReceivedMeasurement(profileMeasurement));
		// tslint:disable-next-line: no-empty
	} catch (e) {}
}

export function* loadDashboardMeasurementDiagram(action: Object): ReduxGenerator {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return;
	}

	const isMigrosAuthenticated = yield select(getIsMigrosAuthenticated);
	if (!isMigrosAuthenticated) {
		return void 0;
	}

	try {
		const { trackingDiagrams = [] } = yield call(
			DashboardApi.fetchDashboardMeasurementDiagram,
			(action as any).selectedType as any
		) as any;
		yield put(actionCreators.doReceivedMeasurementDiagram(trackingDiagrams));
		// tslint:disable-next-line: no-empty
	} catch (e) {}
}

export function* postDashboardMeasurement(action: any): ReduxGenerator {
	const isOnline = yield select(getIsOnline);
	if (!isOnline) {
		return yield put(connectionAC.doTrackNetworkSaveRequestError());
	}

	yield put(sequenceAC.doStartSequence(Sequences.DASHBOARD_MEASUREMENT_UPDATING));

	const savedItem = yield call(DashboardApi.postDashboardMeasurement, {
		weight: action.measurement.weight,
		waist: action.measurement.waist,
		bodyFat: action.measurement.bodyFat,
	});

	const model = new EventWrapper(savedItem);

	yield put(actionCreators.doSaveMeasurementSuccess(model.getData() as any));
	yield put(eventsAC.doAddEvents(model.getEvents() as any));

	// @ts-ignore
	yield fork(profileSagas.getUserData.bind(this, { force: true, preventUpdateLoadingState: true }));

	yield loadDashboard({ preventUpdateLoadingState: true });

	yield put(actionCreators.doRequestMeasurementDiagram(MEASUREMENT_DIAGRAM_TYPE.WEIGHT as any));
	yield put(sequenceAC.doFinishSequence(Sequences.DASHBOARD_MEASUREMENT_UPDATING));
	yield fork(programOverviewSagas.loadProgramOverview);
}
